import { deviceTimeZone } from './platform';

/**
 * The app's clock. Normally real time; screenshots and demos can freeze it with
 * `?now=2026-10-10T14:00:00-05:00` so the Now card and countdowns are reproducible.
 */
let frozen: number | null = null;
let zone: string | null = null;

if (typeof location !== 'undefined') {
  const params = new URLSearchParams(location.search);
  const now = params.get('now');
  if (now) {
    const t = Date.parse(now);
    if (!Number.isNaN(t)) frozen = t;
  }
  const tz = params.get('tz');
  if (tz) zone = tz;
}

export function now(): number {
  return frozen ?? Date.now();
}

/** The zone "today" is measured in: where the device is. */
export function hereZone(): string {
  return zone ?? deviceTimeZone();
}

export function isFrozen(): boolean {
  return frozen !== null;
}
